export default __webpack_public_path__ + "static/ProdigySans-Regular-b4ca9f5d7f5099b6c6988293da1bd3ad.woff2";